import tabletrans from "../../translate/tables";
import Pagination from "material-ui-flat-pagination";

function UserPaging(props) {
  const { page = 0, limit = 10, size = 0, lang, onChange } = props;

  const offset = page * limit;

  const handlePageChange = (event, newOffset) => {
    const newPage = Math.floor(newOffset / limit);

    if (onChange) {
      onChange(newPage, limit);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const newLimit = Number(event.target.value);

    if (onChange) {
      // با تغییر تعداد ردیف، برگرد به صفحه اول
      onChange(0, newLimit);
    }
  };

  return (
    <div className="order-list-footer">
      <div className="dense-btn">
        <input
          className="switch-input"
          type="checkbox"
          id="user-pagination-switch"
        />

        <label
          className="switch-label"
          htmlFor="user-pagination-switch"
        ></label>

        <p></p>
      </div>

      <div className="per-page">
        <p>{tabletrans.rowsPerPage[lang.lang]}</p>

        <select
          name="userPageSize"
          value={limit}
          onChange={handleRowsPerPageChange}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={500}>500</option>
        </select>
      </div>

      {Number(size) > Number(limit) ? (
        <div className="page-counter">
          <Pagination
            limit={limit}
            offset={offset}
            otherPageColor="default"
            currentPageColor="primary"
            total={Number(size)}
            onClick={handlePageChange}
          />
        </div>
      ) : (
        <div className="page-counter"></div>
      )}
    </div>
  );
}

export default UserPaging;
